import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-data-survey-question-builder',
  templateUrl: './data-survey-question-builder.component.html',
  styleUrls: ['./data-survey-question-builder.component.scss']
})
export class DataSurveyQuestionBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
